"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof3 = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _variables = require("../common/variables.js");

var _useTheme = _interopRequireDefault(require("../useTheme"));

var _Box = _interopRequireDefault(require("../box/Box"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof3(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var DxcCard = function DxcCard(_ref) {
  var imageSrc = _ref.imageSrc,
      _ref$imageBgColor = _ref.imageBgColor,
      imageBgColor = _ref$imageBgColor === void 0 ? "black" : _ref$imageBgColor,
      imagePadding = _ref.imagePadding,
      _ref$imagePosition = _ref.imagePosition,
      imagePosition = _ref$imagePosition === void 0 ? "before" : _ref$imagePosition,
      linkHref = _ref.linkHref,
      onClick = _ref.onClick,
      _ref$imageCover = _ref.imageCover,
      imageCover = _ref$imageCover === void 0 ? false : _ref$imageCover,
      margin = _ref.margin,
      contentPadding = _ref.contentPadding,
      _ref$tabIndex = _ref.tabIndex,
      tabIndex = _ref$tabIndex === void 0 ? 0 : _ref$tabIndex,
      _ref$outlined = _ref.outlined,
      outlined = _ref$outlined === void 0 ? true : _ref$outlined,
      children = _ref.children;
  var colorsTheme = (0, _useTheme["default"])();

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      isHovered = _useState2[0],
      changeIsHovered = _useState2[1];

  var imageComponent = /*#__PURE__*/_react["default"].createElement(ImageContainer, {
    imageBgColor: imageBgColor
  }, /*#__PURE__*/_react["default"].createElement(TagImage, {
    imagePadding: imagePadding,
    cover: imageCover,
    src: imageSrc
  }));

  return /*#__PURE__*/_react["default"].createElement(StyledDxcCard, {
    margin: margin,
    onMouseEnter: function onMouseEnter() {
      return changeIsHovered(true);
    },
    onMouseLeave: function onMouseLeave() {
      return changeIsHovered(false);
    },
    onClick: onClick,
    hasAction: onClick || linkHref,
    tabIndex: onClick || linkHref ? tabIndex : -1,
    as: linkHref && "a",
    href: linkHref
  }, /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    shadowDepth: !outlined ? 0 : isHovered && (onClick || linkHref) ? 2 : 1
  }, /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: colorsTheme.card
  }, /*#__PURE__*/_react["default"].createElement(CardContainer, {
    hasAction: onClick || linkHref,
    imagePosition: imagePosition
  }, imageSrc && imagePosition === "before" && imageComponent, /*#__PURE__*/_react["default"].createElement(CardContent, {
    contentPadding: contentPadding
  }, children), imageSrc && imagePosition === "after" && imageComponent))));
};

var StyledDxcCard = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  display: inline-flex;\n  cursor: ", ";\n  outline: ", ";\n  margin: ", ";\n  margin-top: ", ";\n  margin-right: ", ";\n  margin-bottom: ", ";\n  margin-left: ", ";\n  text-decoration: none;\n\n  ", "\n"])), function (_ref2) {
  var hasAction = _ref2.hasAction;
  return hasAction && "pointer" || "unset";
}, function (_ref3) {
  var hasAction = _ref3.hasAction;
  return !hasAction && "none";
}, function (_ref4) {
  var margin = _ref4.margin;
  return margin && (0, _typeof2["default"])(margin) !== "object" ? _variables.spaces[margin] : "0px";
}, function (_ref5) {
  var margin = _ref5.margin;
  return margin && margin.top ? _variables.spaces[margin.top] : "";
}, function (_ref6) {
  var margin = _ref6.margin;
  return margin && margin.right ? _variables.spaces[margin.right] : "";
}, function (_ref7) {
  var margin = _ref7.margin;
  return margin && margin.bottom ? _variables.spaces[margin.bottom] : "";
}, function (_ref8) {
  var margin = _ref8.margin;
  return margin && margin.left ? _variables.spaces[margin.left] : "";
}, function (_ref9) {
  var hasAction = _ref9.hasAction;
  return hasAction && ":focus {\n    outline: #0095ff auto 1px;\n  }";
});

var CardContainer = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  display: inline-flex;\n  height: ", ";\n  width: ", ";\n  &:hover {\n    border-color: ", ";\n  }\n"])), function (props) {
  return props.theme.height;
}, function (props) {
  return props.theme.width;
}, function (_ref10) {
  var hasAction = _ref10.hasAction;
  return hasAction ? "" : "unset";
});

var TagImage = _styledComponents["default"].img(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  height: ", ";\n  width: ", ";\n  object-fit: ", ";\n"])), function (_ref11) {
  var imagePadding = _ref11.imagePadding;
  return !imagePadding ? "100%" : "calc(100% - ".concat(_variables.spaces[imagePadding], " - ").concat(_variables.spaces[imagePadding], ")");
}, function (_ref12) {
  var imagePadding = _ref12.imagePadding;
  return !imagePadding ? "100%" : "calc(100% - ".concat(_variables.spaces[imagePadding], " - ").concat(_variables.spaces[imagePadding], ")");
}, function (_ref13) {
  var cover = _ref13.cover;
  return cover ? "cover" : "contain";
});

var ImageContainer = _styledComponents["default"].div(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n  width: 35%;\n  height: 100%;\n  flex-shrink: 0;\n  background: ", ";\n  justify-content: center;\n  align-items: center;\n  display: inline-flex;\n"])), function (_ref14) {
  var imageBgColor = _ref14.imageBgColor;
  return imageBgColor;
});

var CardContent = _styledComponents["default"].div(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["\n  flex-grow: 1;\n  padding: ", ";\n  padding-top: ", ";\n  padding-right: ", ";\n  padding-bottom: ", ";\n  padding-left: ", ";\n  overflow: hidden;\n"])), function (_ref15) {
  var contentPadding = _ref15.contentPadding;
  return contentPadding && (0, _typeof2["default"])(contentPadding) !== "object" ? _variables.spaces[contentPadding] : "0px";
}, function (_ref16) {
  var contentPadding = _ref16.contentPadding;
  return contentPadding && (0, _typeof2["default"])(contentPadding) === "object" && contentPadding.top ? _variables.spaces[contentPadding.top] : "";
}, function (_ref17) {
  var contentPadding = _ref17.contentPadding;
  return contentPadding && (0, _typeof2["default"])(contentPadding) === "object" && contentPadding.right ? _variables.spaces[contentPadding.right] : "";
}, function (_ref18) {
  var contentPadding = _ref18.contentPadding;
  return contentPadding && (0, _typeof2["default"])(contentPadding) === "object" && contentPadding.bottom ? _variables.spaces[contentPadding.bottom] : "";
}, function (_ref19) {
  var contentPadding = _ref19.contentPadding;
  return contentPadding && (0, _typeof2["default"])(contentPadding) === "object" && contentPadding.left ? _variables.spaces[contentPadding.left] : "";
});

var _default = DxcCard;
exports["default"] = _default;